/**
 * Format an ISO timestamp into a short relative phrase: "Just now", "5m ago",
 * "3h ago", "2d ago", "Mar 5". Returns "" when input is missing/invalid.
 *
 * Designed for dashboard chrome where we want a glanceable "Done · 2d ago"
 * pill without pulling in date-fns.
 */
export function relativeTime(iso) {
  if (!iso) return "";
  const then = new Date(iso);
  if (Number.isNaN(then.getTime())) return "";
  const diffSec = Math.max(0, Math.round((Date.now() - then.getTime()) / 1000));

  if (diffSec < 45) return "Just now";
  if (diffSec < 90) return "1m ago";
  const min = Math.round(diffSec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.round(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.round(hr / 24);
  if (day < 7) return `${day}d ago`;
  if (day < 30) return `${Math.round(day / 7)}w ago`;
  // Older than ~a month — show a short date.
  return then.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}
